// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607090834/js/" + chunkId + "." + {"44":"b8c234fe","225":"e76b2523","481":"db2b99e4","486":"9529b173","770":"ff9da810"}[chunkId] + ".0.06695906689448916.chunk.js";
};